import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Reusable avatar display component. Shows the student's saved profile
 * picture if available, falling back to initials derived from the name.
 */
@Component({
  selector: 'app-user-avatar',
  imports: [CommonModule],
  templateUrl: './user-avatar.html',
  styleUrl: './user-avatar.css',
})
export class UserAvatar {
  /** The saved avatar image URL (profile_picture_path from the backend). */
  @Input() imageUrl: string | null | undefined = null;

  /** Full name used to derive initials when no image is available. */
  @Input() name: string = '';

  /** Optional background color for the initials circle. */
  @Input() color: string = '#1E468B';

  /** Tracks whether the image failed to load. Falls back to initials. */
  imageError = false;

  /**
   * Returns up to two uppercase initials from the name input.
   * @returns {string}
   */
  get initials(): string {
    const parts = this.name.trim().split(' ').filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  onImageError(): void {
    this.imageError = true;
  }
}
